import 'expose-loader?exposes=bootstrap!bootstrap';
import 'expose-loader?exposes=React!react';
import 'expose-loader?exposes=ReactDOM!react-dom';

import '../components/Util/responsiveImages';
import '../fonts/fontello/css/fontello.css';
import { registerRegionRedirect } from '../serviceWorker/registerRegionRedirect';
import '../styles/main.scss';
import './icons';

import * as CommonComponents from '../components/commonComponents';

const Components = { ...CommonComponents };

global['Components'] = Components;

void registerRegionRedirect();

export { Components };
